import React from "react";

// The Barcelona pavement tile, the panot, as a flat line drawing repeated to
// fill its box: a square with a groove, four ring petals on the diagonals and
// a ring at the centre that the petals pass under. Each ring is a band drawn
// as its two edges, so there is no fill and it works on any ground. Lines
// take the svg's `color`; where it is placed, the opacity and fades are CSS.
//
// The pattern is defined inside the svg that uses it, so `currentColor`
// resolves there; `id` has to be unique on the page. Decoration only.

const TILE = 96;
const PETALS = [
  [32, 32],
  [68, 32],
  [32, 68],
  [68, 68],
];
const PETAL_R = 18;
const CENTRE_R = 16.5;
const EDGE = 2.85;

function Ring({ cx, cy, r }) {
  return (
    <>
      <circle cx={cx} cy={cy} r={r - EDGE} />
      <circle cx={cx} cy={cy} r={r + EDGE} />
    </>
  );
}

// `centred` starts the tiling on the box's vertical midline, so a field laid
// symmetrically around centred text mirrors on both sides.
function Panot({ id, className, centred = false }) {
  return (
    <svg className={className} aria-hidden="true" focusable="false">
      <defs>
        <mask id={`${id}-under`} maskUnits="userSpaceOnUse" x="0" y="0" width="100" height="100">
          <rect width="100" height="100" fill="#fff" />
          <circle cx="50" cy="50" r={CENTRE_R + EDGE + 0.85} fill="#000" />
        </mask>
        <pattern
          id={id}
          x={centred ? "50%" : 0}
          width={TILE}
          height={TILE}
          patternUnits="userSpaceOnUse"
        >
          <g fill="none" stroke="currentColor" strokeWidth="1.3">
            <rect x="1.5" y="1.5" width="93" height="93" rx="3" />
            <g transform="translate(10 10) scale(0.76)">
              <g mask={`url(#${id}-under)`}>
                {PETALS.map(([cx, cy]) => (
                  <Ring key={`${cx}-${cy}`} cx={cx} cy={cy} r={PETAL_R} />
                ))}
              </g>
              <Ring cx={50} cy={50} r={CENTRE_R} />
            </g>
          </g>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${id})`} />
    </svg>
  );
}

// The corner of pavement at the top of a page (home.css).
export function PavementCorner({ id }) {
  return (
    <div className="pf-pavement" aria-hidden="true">
      <Panot id={id} className="pf-pavement__tiles" />
    </div>
  );
}

// Pavement either side of a centred headline, fading out toward the text and
// toward the page's edges; a corner again where the text is left-aligned
// (home.css).
export function PavementSides({ id, className = "" }) {
  return (
    <div className={`pf-pavement pf-pavement--sides ${className}`.trim()} aria-hidden="true">
      <Panot id={id} className="pf-pavement__tiles" centred />
    </div>
  );
}

export default Panot;
